import React, { useState } from 'react';
import {
    Form,
    Input,
    Button,
    Spin,
    notification,
    Row,
    Col,
    Divider,
    Typography,
} from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { resetPasswordApi } from '../../../api/user';
import {
    validatePassword,
    validateTextHasCapitalize,
    validateTextHasLowercase,
    validateTextHasNumber,
    validateTextHasCharacter,
} from '../../../utils/formValidation';

import './ResetPasswordForm.scss';

const ResetPasswordForm = (props) => {
    const { user } = props;
    const { Text } = Typography;

    const [loading, setLoading] = useState(false);
    const [hasUpperCase, setHasUpperCase] = useState(false);
    const [hasLowerCase, setHasLowerCase] = useState(false);
    const [hasNumber, setHasNumber] = useState(false);
    const [hasCharacter, setHasCharacter] = useState(false);
    const [lenghtCorrect, setLenghtCorrect] = useState(false);

    const layout = {
        labelCol: {
            xs: {
                span: 24,
            },
            sm: {
                span: 8,
            },
            lg: {
                span: 6,
            },
        },
        wrapperCol: {
            xs: {
                span: 24,
            },
            sm: {
                span: 16,
            },
            lg: {
                span: 14,
            },
        },
    };
    const tailLayout = {
        wrapperCol: {
            xs: {
                span: 24,
                offset: 0,
            },
            sm: {
                span: 16,
                offset: 8,
            },
            lg: {
                span: 8,
                offset: 8,
            },
        },
    };

    const onFinish = async (values) => {
        setLoading(true);
        let data = values;
        data['email'] = user.email;
        data['token'] = user.token;

        const result = await resetPasswordApi(data);

        if (result === undefined) {
            setLoading(false);

            notification['error']({
                message: 'Ocurrió un error, Intentelo mas tarde',
            });

            setTimeout(() => {
                window.location.href = '/';
            }, 3000);

            return false;
        }

        if (result.statusCode === 200) {
            setLoading(false);

            notification['success']({
                message: 'Operación exitosa',
            });

            setTimeout(() => {
                window.location.href = '/';
            }, 3000);
        } else {
            let messageError = 'Ocurrió un error, Intentelo otra vez';

            if (result.statusCode === 409) {
                messageError = 'El token ha aspirado.';
            }

            if (result.statusCode === 400) {
                messageError = result.message;
            }

            setLoading(false);

            notification['error']({
                message: messageError,
            });
        }
    };

    const checkPassword = (text) => {
        if (validateTextHasCapitalize(text)) {
            setHasUpperCase(true);
        } else {
            setHasUpperCase(false);
        }

        if (validateTextHasLowercase(text)) {
            setHasLowerCase(true);
        } else {
            setHasLowerCase(false);
        }

        if (validateTextHasNumber(text)) {
            setHasNumber(true);
        } else {
            setHasNumber(false);
        }

        if (validateTextHasCharacter(text)) {
            setHasCharacter(true);
        } else {
            setHasCharacter(false);
        }

        if (text.length >= 6) {
            setLenghtCorrect(true);
        } else {
            setLenghtCorrect(false);
        }
    };

    return (
        <Spin tip='Cargando...' spinning={loading}>
            <Form
                {...layout}
                onFinish={onFinish}
                className='reset-password-form'
            >
                <Form.Item
                    name='password'
                    label='Contraseña'
                    rules={[
                        {
                            required: true,
                            message: 'Por favor ingrese una contraseña',
                        },
                        () => ({
                            validator(rule, value) {
                                if (validatePassword(value)) {
                                    return Promise.resolve();
                                } else if (!validatePassword(value)) {
                                    return Promise.reject(
                                        'La contrase\u00F1a nueva debe de tener  mínimo 6 o más caracteres, por lo menos una may\u00FAscula, una minúscula, un número  y un car\u00E1cter especial'
                                    );
                                }
                            },
                        }),
                    ]}
                    hasFeedback
                >
                    <Input.Password
                        onChange={(e) => checkPassword(e.target.value)}
                    />
                </Form.Item>

                <div className='validate-password'>
                    <Row justify='center'>
                        <Col xs={24} sm={8} lg={8}>
                            <Divider>La contraseña debe incluir:</Divider>
                            <ul>
                                <li>
                                    {hasUpperCase && (
                                        <Text type='success'>
                                            <CheckCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Una mayúscula{' '}
                                        </Text>
                                    )}
                                    {!hasUpperCase && (
                                        <Text type='danger'>
                                            <CloseCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Una mayúscula{' '}
                                        </Text>
                                    )}
                                </li>
                                <li>
                                    {hasLowerCase && (
                                        <Text type='success'>
                                            <CheckCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Una minúscula{' '}
                                        </Text>
                                    )}
                                    {!hasLowerCase && (
                                        <Text type='danger'>
                                            <CloseCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Una minúscula{' '}
                                        </Text>
                                    )}
                                </li>
                                <li>
                                    {hasNumber && (
                                        <Text type='success'>
                                            <CheckCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Un número{' '}
                                        </Text>
                                    )}
                                    {!hasNumber && (
                                        <Text type='danger'>
                                            <CloseCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Un número{' '}
                                        </Text>
                                    )}
                                </li>
                                <li>
                                    {hasCharacter && (
                                        <Text type='success'>
                                            <CheckCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Un carácter:{' '}
                                            {'?()!@#$%^&*[]"\';:_-<>. =+/ '}{' '}
                                        </Text>
                                    )}
                                    {!hasCharacter && (
                                        <Text type='danger'>
                                            <CloseCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Un carácter:{' '}
                                            {'?()!@#$%^&*[]"\';:_-<>. =+/'}
                                        </Text>
                                    )}
                                </li>
                                <li>
                                    {lenghtCorrect && (
                                        <Text type='success'>
                                            <CheckCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Tiene 6 o más caracteres{' '}
                                        </Text>
                                    )}
                                    {!lenghtCorrect && (
                                        <Text type='danger'>
                                            <CloseCircleFilled
                                                style={{ marginRight: 8 }}
                                            />
                                            Tiene 6 o más caracteres{' '}
                                        </Text>
                                    )}
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </div>

                <Form.Item
                    name='confirmPassword'
                    label='Confirmar Contraseña'
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                        {
                            required: true,
                            message: 'Por favor ingrese la contraseña anterior',
                        },
                        ({ getFieldValue }) => ({
                            validator(rule, value) {
                                if (
                                    !value ||
                                    getFieldValue('password') === value
                                ) {
                                    return Promise.resolve();
                                }

                                return Promise.reject(
                                    'Las dos contraseñas ingresadas no son iguales'
                                );
                            },
                        }),
                    ]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    {...tailLayout}
                    className='reset-password-form__button'
                >
                    <Button type='primary' htmlType='submit'>
                        Enviar
                    </Button>
                </Form.Item>
            </Form>
        </Spin>
    );
};

export default ResetPasswordForm;
